import { selectedProductQueryParam } from '@/constants/productSelection';

export function nextProductSearchParams(
  current: URLSearchParams,
  productId: string | null,
): URLSearchParams {
  const nextParams = new URLSearchParams(current);

  if (!productId) {
    nextParams.delete(selectedProductQueryParam);
    return nextParams;
  }

  nextParams.set(selectedProductQueryParam, productId);
  return nextParams;
}

export function shouldApplyProductQuery(
  queryId: string | null | undefined,
  selectedId: string,
  productIds: readonly string[],
): boolean {
  const requestedProductId = queryId?.trim() ?? '';

  if (!requestedProductId) {
    return false;
  }

  if (selectedId.trim()) {
    return false;
  }

  return productIds.includes(requestedProductId);
}
